import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Panel } from 'primereact/panel';
import { ProgressSpinner } from 'primereact/progressspinner';
import { InputComponent } from '../../../../components/InputComponent';
import { ProveedorService } from '../../../../service/ProveedorService';
import * as generic from '../../../../components/Generico';
import { InfoPep } from '../../../../models/ficha/InfoPep';
import { PepAfinidad } from '../../common/PepAfinidad';
import { BottomActionBar } from '../../../../components/ui/BottomActionBar';

export const DatosPep = ({ toast, id, permss, catalogos, handlePrev, next, nuevoProveedor, soloLectura }) => {
    const omodel = new InfoPep({ tipoFrmEmpresa: catalogos?.tipoFrmEmpresa });
    const defaultValues = generic.funDefault(omodel.model);
    const { control, formState: { errors }, handleSubmit, reset, setError, setValue } = useForm({ defaultValues, shouldTrim: true });
    const proveedorServicio = new ProveedorService();
    const { inText, inDrop, inCalendar } = InputComponent({ omodel, errors, control, permss, id, soloLectura });
    // Estados locales
    const [esSocio, setEsSocio] = useState(false);
    const [relacionPep, setRelacionPep] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [isSaving, setIsSaving] = useState(false);

    useEffect(() => {
        editFicha();
        // eslint-disable-next-line
    }, [id]);

    const onSubmit = (data) => {
        setIsSaving(true);
        data.id = id;
        data.seccion = 'seccion3'; // Identificador para el backend
        // Transformación de datos PEP antes de enviar
        if (esSocio) {
            data.fecha_pep = generic.dateToString(data.fecha_pep);
            if (data.fecha_no_pep) {
                data.fecha_no_pep = generic.dateToString(data.fecha_no_pep);
            }
        } else {
            // Si marca "No", limpiamos los campos para que el backend no guarde basura
            delete data.fecha_pep;
            delete data.fecha_no_pep;
            data.nombre_pep = null;
            data.cargo_pep = null;
            data.institucion_pep = null;
        }

        if (relacionPep) {
            data.fecha_vinculo_pep = generic.dateToString(data.fecha_vinculo_pep);
            if (data.fecha_culminacion_pep) {
                data.fecha_culminacion_pep = generic.dateToString(data.fecha_culminacion_pep);
            }
        } else {
            delete data.fecha_vinculo_pep;
            delete data.fecha_culminacion_pep;
            data.nombre_vinculo_pep = null;
            data.cargo_vinculo_pep = null;
            data.institucion_vinculo_pep = null;
        }

        proveedorServicio.editarProveedor(data).then(res => {
            nuevoProveedor(res.data);
            generic.funcSuccess(res, toast);
            next();
        }).catch(error => {
            generic.funcError(error, toast, setError);
        }).finally(() => {
            setIsSaving(false);
        });
    }

    const editFicha = () => {
        setIsLoading(true);
        proveedorServicio.consultarProveedor(id, { seccion: 'seccion3' }).then(res => {
            const _prov = res.data.proveedor;

            if (!_prov) {
                reset(defaultValues);
                return;
            }

            // Manejo de fechas si es socio/PEP
            if (_prov.socio?.cat_id) {
                _prov.fecha_pep = generic.stringToDate(_prov.fecha_pep);
                if (_prov.fecha_no_pep) {
                    _prov.fecha_no_pep = generic.stringToDate(_prov.fecha_no_pep);
                }
                setEsSocio(true);
            } else {
                setEsSocio(false);
            }

            // Manejo de fechas si está relacionado con un PEP
            if (_prov.relacion_pep?.cat_id) {
                _prov.fecha_vinculo_pep = generic.stringToDate(_prov.fecha_vinculo_pep);
                if (_prov.fecha_culminacion_pep) {
                    _prov.fecha_culminacion_pep = generic.stringToDate(_prov.fecha_culminacion_pep);
                }
                setRelacionPep(true);
            } else {
                setRelacionPep(false);
            }

            reset(generic.renewValues(_prov, omodel.model));
        }).finally(() => {
            setIsLoading(false);
        });
    }

    const onError = () => {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Se detectaron errores, por favor revise el formulario para corregir.', life: 3000 });
    }

    // Handler unificado para los selects "socio" (condición PEP) y "relacion_pep" (vínculo con un PEP)
    const onChangePep = (e, esCampoPep) => {
        if (esCampoPep) {
            setEsSocio(e.value?.cat_id);
            setValue('nombre_pep', '');
            setValue('cargo_pep', '');
            setValue('institucion_pep', '');
            setValue('fecha_pep', null);
            setValue('fecha_no_pep', null);
        } else {
            setRelacionPep(e.value?.cat_id);
            setValue('nombre_vinculo_pep', '');
            setValue('cargo_vinculo_pep', '');
            setValue('institucion_vinculo_pep', '');
            setValue('fecha_vinculo_pep', null);
            setValue('fecha_culminacion_pep', null);
        }
    }

    if (isLoading) {
        return (
            <div className="flex flex-column align-items-center justify-content-center p-5">
                <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="4" animationDuration=".5s" />
                <span className="mt-3 text-color-secondary font-medium text-lg">Consultando información...</span>
            </div>
        );
    }

    return (
        <form id="datosPep" onSubmit={handleSubmit(onSubmit, onError)} className="p-fluid">
            <Panel header={generic.renderPanelHeader('5', 'Información de Controles de Prevención de Lavado de Activos, Financiamiento del Terrorismo y Otros Delitos', 'pi pi-shield')} className="panel-ficha shadow-1 mb-4">
                <div className="col-12 mb-3">
                    <div className="flex align-items-center">
                        <span className="text-800 font-bold text-base mr-3 flex align-items-center gap-2">
                            <i className="pi pi-shield text-primary"></i>
                            CUMPLIMIENTO Y PREVENCIÓN DE RIESGOS
                        </span>
                        <div className="border-bottom-1 border-300 flex-grow-1" style={{ height: '1px' }}></div>
                    </div>
                </div>

                <div className="formgrid grid">
                    {inDrop('politicas', generic.estadosSiNo, { lab: omodel.optionLabel }, 12)}
                    {inDrop('sancion', generic.estadosSiNo, { lab: omodel.optionLabel }, 12)}
                </div>
            </Panel>

            <Panel header={generic.renderPanelHeader('6', 'Persona Expuesta Políticamente (PEP) Describir en el Caso que la Persona Natural, Socios, Accionistas o Directivos Ocupen estos Cargos', 'pi pi-building-columns')} className="panel-ficha shadow-1 mb-4">
                <div className="field col-12 p-3 text-justify line-height-3 text-700 bg-blue-50 border-round border-left-3 border-blue-500 mb-4">
                    <div className="flex align-items-center gap-2 mb-3">
                        <i className="pi pi-info-circle text-blue-600 text-lg"></i>
                        <span className="font-bold text-blue-900">Definición de PEP</span>
                    </div>
                    {omodel.strPep}
                </div>

                <div className="col-12 mb-3 mt-3">
                    <div className="flex align-items-center">
                        <span className="text-800 font-bold text-base mr-3 flex align-items-center gap-2">
                            <i className="pi pi-user text-primary"></i>
                            CONDICIÓN DE PEP
                        </span>
                        <div className="border-bottom-1 border-300 flex-grow-1" style={{ height: '1px' }}></div>
                    </div>
                </div>

                <div className="formgrid grid mb-4">
                    {inDrop('socio', generic.estadosSiNo, { lab: omodel.optionLabel, chn: onChangePep, val: true }, 12)}
                    {esSocio && (
                        <>
                            {inText('nombre_pep', { icon: 'pi pi-user' }, 6)}
                            {inText('cargo_pep', { icon: 'pi pi-briefcase' }, 6)}
                            {inText('institucion_pep', { icon: 'pi pi-building' }, 12)}
                            {inCalendar('fecha_pep', {}, 6)}
                            {inCalendar('fecha_no_pep', {}, 6)}
                        </>
                    )}
                </div>

                <div className="col-12 mb-3">
                    <div className="flex align-items-center">
                        <span className="text-800 font-bold text-base mr-3 flex align-items-center gap-2">
                            <i className="pi pi-users text-primary"></i>
                            FAMILIARES O RELACIONADOS
                        </span>
                        <div className="border-bottom-1 border-300 flex-grow-1" style={{ height: '1px' }}></div>
                    </div>
                </div>

                <div className="col-12 px-0 mb-4">
                    <PepAfinidad tipo='proveedor' id={id} toast={toast} permss={permss} catalogos={catalogos} soloLectura={soloLectura} />
                </div>

                <div className="col-12 mt-3 mb-3">
                    <div className="flex align-items-center">
                        <span className="text-800 font-bold text-base mr-3 flex align-items-center gap-2">
                            <i className="pi pi-share-alt text-primary"></i>
                            VÍNCULO CON UN PEP
                        </span>
                        <div className="border-bottom-1 border-300 flex-grow-1" style={{ height: '1px' }}></div>
                    </div>
                </div>

                <div className="formgrid grid">
                    {inDrop('relacion_pep', generic.estadosSiNo, { lab: omodel.optionLabel, chn: onChangePep, val: false }, 12)}
                    {relacionPep && (
                        <>
                            {inText('relacion_vinculo_pep', { icon: 'pi pi-user' }, 6)}
                            {inText('nombre_vinculo_pep', { icon: 'pi pi-user' }, 6)}
                            {inText('cargo_vinculo_pep', { icon: 'pi pi-briefcase' }, 6)}
                            {inText('institucion_vinculo_pep', { icon: 'pi pi-building' }, 6)}
                            {inCalendar('fecha_vinculo_pep', {}, 6)}
                            {inCalendar('fecha_culminacion_pep', {}, 6)}
                        </>
                    )}
                </div>
            </Panel>

            <BottomActionBar formId="datosPep" onPrev={handlePrev} onNext={next} loading={isSaving} isReadOnly={soloLectura} />
        </form>
    );
}